<span
  class="dot"
  [matTooltip]="alarmCounter"
  [style.background-color]="severityColor"
  [style.opacity]="alarmCounter == 0 ? 0.2 : 1"
  [class.light-text]="lightText"
  ><span class="counter">{{ alarmCounter > maxCounterToShow ? '...' : alarmCounter }}</span></span
>
